import styled from 'styled-components'

export const QRCodeContainer = styled.div`
  margin: 32px 0;
`
